interface Args {
  /** The shop or an order slot is still loading. */
  loading: boolean;
  modalOpen: boolean;
  isOrderMethodInfoComplete: boolean;
  isValidSlot: boolean;
  hasLiveOrders: boolean;
  /** The guest closed the modal this visit. */
  wasDismissed: boolean;
  /** The QR code chose the order type, the location and the table: nothing is asked. */
  isAtTable: boolean;
  hasMultipleCompanies: boolean;
  needsDeliveryAddressInput: boolean;
}

/**
 * Whether the menu opens the order-method modal by itself (after its 4 s delay): the guest still has
 * something to choose, and nothing else has settled it.
 */
export default function shouldAutoOpenOrderMethodModal({
  loading,
  modalOpen,
  isOrderMethodInfoComplete,
  isValidSlot,
  hasLiveOrders,
  wasDismissed,
  isAtTable,
  hasMultipleCompanies,
  needsDeliveryAddressInput,
}: Args): boolean {
  if (
    loading ||
    modalOpen ||
    (isOrderMethodInfoComplete && isValidSlot) ||
    !hasLiveOrders ||
    wasDismissed ||
    isAtTable
  ) {
    return false;
  }

  return hasMultipleCompanies || !isValidSlot || needsDeliveryAddressInput;
}
